"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncState = void 0;
const react_1 = require("react");
const deferred_1 = require("./deferred");
const event_callback_hook_1 = require("./event-callback-hook");
/**
 * Enhanced useState. Setter function returns promise resolved in next render.
 */
function useAsyncState() {
    const callRef = (0, react_1.useRef)();
    const [state, setState] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = callRef.current) === null || _a === void 0 ? void 0 : _a.resolve();
    }, [state]);
    const asyncSetState = (0, event_callback_hook_1.useEventCallback)(async function (value) {
        var _a;
        const call = new deferred_1.Deferred();
        callRef.current = call;
        // setTimeout(() => {
        // if (value === state) {
        //   callRef.current?.resolve();
        // } else {
        //   setState(value);
        // }
        // }, 1000);
        if (value === state) {
            (_a = callRef.current) === null || _a === void 0 ? void 0 : _a.resolve();
        }
        else {
            setState(value);
        }
        return call.promise;
    });
    return [state, asyncSetState];
}
exports.useAsyncState = useAsyncState;
//# sourceMappingURL=async-state-hook.js.map